// Global Instructions Rule Applied!
import React from 'react'

/**
 * Displays contacts as blue rounded badges with full names
 * @param {object} props
 * @param {Array<any>} [props.contacts] - Contact objects; the badge shows `label` or `name`, and the id is read from `value` / `id` / `data.id` unless `getContactId` is given
 * @param {(contact: any, contactId: string) => void} [props.onContactClick] - Callback when a badge is clicked; omit it and the badges are not clickable
 * @param {(contact: any) => string | null | undefined} [props.getContactId] - Overrides how a contact's id is read
 * @param {'small' | 'default'} [props.size] - Badge size (default: 'default')
 * @param {'start' | 'end'} [props.align] - Align badges to start or end when wrapping (default: 'start')
 */
export const ContactBadges = ({ contacts = [], onContactClick, getContactId, size = 'default', align = 'start' }) => {
  if (!contacts || contacts.length === 0) {
    return '-'
  }

  const handleContactClick = (contact, e) => {
    if (onContactClick) {
      e.stopPropagation()
      e.preventDefault()
      const contactId = getContactId
        ? getContactId(contact)
        : contact?.value || contact?.id || contact?.data?.id || null
      if (contactId) {
        onContactClick(contact, contactId)
      }
    }
  }

  const justifyClass = align === 'end' ? 'justify-end' : 'justify-start'

  return (
    <div className={`flex flex-wrap items-center gap-1 ${justifyClass}`}>
      {contacts.map((contact, index) => {
        const isClickable = !!onContactClick
        const contactId = getContactId
          ? getContactId(contact)
          : contact?.value || contact?.id || contact?.data?.id || null

        const sizeClasses = size === 'small' ? 'text-[10px] px-1 py-px' : 'text-sm pl-1 pr-1'
        return (
          <div
            key={index}
            onClick={isClickable && contactId ? (e) => handleContactClick(contact, e) : undefined}
            className={`inline-flex items-center justify-center rounded-full text-black ${sizeClasses} bg-blue-100 border border-blue-400 whitespace-nowrap ${
              isClickable && contactId ? 'cursor-pointer hover:bg-blue-200 hover:border-blue-500' : ''
            }`}
          >
            {contact?.label || contact?.name || 'Unknown'}
          </div>
        )
      })}
    </div>
  )
}
